module.exports = __webpack_public_path__ + "static/media/image-na-alt.6a8e386b.png";